import { useCallback, useState } from 'react';
import { Notification, NotificationInput } from '~/contexts/NotificationContext';
import { randomShortId } from '~/adapters/browser/crypto';
import { calculateNotificationTimeout } from './calculateNotificationTimeout';

export function useNotificationState(): [Notification[], (notification: NotificationInput) => void] {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const addNotification = useCallback((notification: NotificationInput) => {
        const id = randomShortId();
        const { autoClose = true, ...rest } = notification;
        const newNotification = { id, closable: !autoClose, ...rest };
        setNotifications((n) => [...n, newNotification]);
        if (autoClose) {
            setTimeout(
                () =>
                    setNotifications((current) => {
                        return current.filter((not) => not !== newNotification);
                    }),
                calculateNotificationTimeout(notification.message),
            );
        }
    }, []);
    return [notifications, addNotification];
}
